import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { environment } from '../../environments/environment';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { OrganizationService } from "../shared/organization.service";

@Injectable({
  providedIn: 'root'
})
export class PostHeadersInterceptor implements HttpInterceptor {
  constructor(private organizationService: OrganizationService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Never touch the OAuth library's own protocol calls (e.g. the code->token POST to
    // /oidc/token): angular-oauth2-oidc sends them form-urlencoded, and forcing
    // Content-Type: application/json below makes the provider try to JSON.parse the
    // `grant_type=...` body and reject it with a 400.
    const isOidcUrl = req.url.startsWith(environment.oidc.issuer);
    if (isOidcUrl) {
      return next.handle(req);
    }
    if (!req.url.startsWith('http') || req.url.startsWith(environment.backend_url)) {
      const organizationId = this.organizationService.getOrganizationId();
      if (organizationId) {
        req = req.clone({
          headers: req.headers.set('organizationid', organizationId),
        });
      }
    }
    if (!req.reportProgress && req.method == 'POST' && !(req.body instanceof FormData)) {
      req = req.clone({
        headers: req.headers.set('Content-Type', 'application/json'),
      });
    }
    return next.handle(req);
  }
}
